import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useInventoryNoteDetail(id, params) {
  return useSWR(
    !!id
      ? {
          path: `/api/v1/inventory-notes/${id}`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useInventoryNoteDetail;
